import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Menu,
  MultiSelect,
  rem,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconCaretDown,
  IconEdit,
  IconFileExport,
  IconFileUpload,
  IconMapRoute,
  IconSearch,
  IconUser,
} from "@tabler/icons-react";
import Avvvatars from "avvvatars-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { getValueById } from "../../_base/helper/FunctionHelper";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../config";
import { _localization } from "../../config/location";
import { green, orange, sky_blue, teal } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { TblDMExpense } from "../../model/TblDMExpense";
import { getBranchSelectMdm } from "../../service/getSelectApi";
import UpdatePointKTKT from "./UpdatePointKTKT";

const PayrollReport = () => {
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  //select
  const dataStatusOption = [
    { value: "TAO_MOI", label: "Tạo mới" },
    { value: "PHAN_CONG", label: "Phân công" },
    { value: "DANG_KIEM_TRA", label: "Đang kiểm tra" },
    { value: "TEST_MOT_PHAN", label: "Test một phần" },
    { value: "TEST_LOI", label: "Test lỗi" },
    { value: "TEST_OK", label: "Test ok" },
    { value: "HUY_PHAN_CONG", label: "Hủy phân công" },
  ];
  const sourceTypeData = [
    { label: "Đơn Hàng", value: "DON_HANG" },
    { label: "Nhập Kho Bảo Hành NCC", value: "NHAP_KHO_BH_NCC" },
    { label: "Nhập Kho Bảo Hành", value: "NHAP_KHO_BH" },
    { label: "Chuyển Đổi Dữ Liệu", value: "CHUYEN_DOI_DU_LIEU" },
    { label: "Xử lý yêu cầu", value: "Xử lý yêu cầu" },
    { label: "Lắp ráp", value: "LAP_RAP" },
    { label: "Khác", value: "KHAC" },
  ];
  const [dataTblBranch, setDataTblBranch] = useState<any[]>([]);
  const [idCn, setIdCn] = useState<string[]>([]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataTestLevel, setDataTestLevel] = useState<any[]>([]);

  const [search, setSearch] = useState<{
    startDate: string;
    endDate: string;
    branchCode: string[];
    sourceType: string[];
    EmpIds: string[];
  }>({
    startDate: new Date(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() +
        7 * 60 * 60 * 1000,
    ).toISOString(),
    endDate: new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    branchCode: [],
    sourceType: [],
    EmpIds: [],
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);

  const [selectMenu, setSelectMenu] = useState<number>(-1);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        Cell: ({ row }) =>
          row.original.branchName ? (
            <Text size="12.5px" fw={500}>
              [{row.original.branchCode}] - {row.original.branchName}
            </Text>
          ) : (
            <></>
          ),
        size: 200,
      },
      {
        accessorKey: "empName",
        header: "Nhân viên kiểm tra",
        size: 225,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue !== null ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.empCode} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <Text fw={500} size="12.5px">
              Chưa tiếp nhận
            </Text>
          ),
      },
      {
        accessorKey: "sourceCode",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "sourceType",
        header: "Nguồn chứng từ",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={getColorSourceType(renderedCellValue?.toString() ?? "")}
            radius={"sm"}
          >
            {getDataSourceType(renderedCellValue?.toString() ?? "")}
          </Badge>
        ),
      },
      {
        accessorKey: "testDifficulty",
        header: "Mức độ test",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null ? (
            <Badge
              color={getColorTestDifficulty(
                renderedCellValue?.toString() ?? "",
              )}
              radius={"sm"}
            >
              {getValueById(
                String(renderedCellValue || ""),
                dataTestLevel,
                "label",
              ) ||
                renderedCellValue ||
                "Không xác định"}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "testPoint",
        header: "Điểm",
        size: 125,
      },
      {
        accessorKey: "modifiedPoint",
        header: "Điểm đã sửa",
        size: 160,
      },
      {
        accessorKey: "testCode",
        header: "Mã kiểm tra",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "testingStatus",
        header: "Trạng thái kiểm tra",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null ? (
            <>
              <Badge
                color={getColorStatus(renderedCellValue?.toString())}
                radius={"sm"}
              >
                {getValueById(
                  renderedCellValue?.toString() ?? "",
                  dataStatusOption,
                  "label",
                )}
              </Badge>
            </>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>{renderedCellValue}</Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "customerTelephone",
        header: "SĐT",
      },
      {
        accessorKey: "modifiedDate",
        header: "Ngày sửa điểm",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "payrollModifiedByName",
        header: "Người sửa điểm",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue !== null ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.payrollModifiedByCode} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "modifiedNote",
        header: "Ghi chú sửa điểm",
      },
      {
        accessorKey: "note",
        header: "Ghi chú kiểm tra",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        size: 70,
        Cell: ({ row }) => (
          <Flex>
            <Menu
              position="left"
              closeOnItemClick={false}
              opened={row.index === selectMenu}
              onChange={() => setSelectMenu(row.index)}
            >
              <Menu.Target>
                <Tooltip label="Chỉnh sửa">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="yellow"
                    size={"md"}
                    p={2}
                  >
                    <IconEdit stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Menu.Target>
              <Menu.Dropdown>
                <UpdatePointKTKT
                  code={
                    row.original.sourceType === "Xử lý yêu cầu"
                      ? row.original.sourceCode
                      : row.original.testCode
                  }
                  type={row.original.sourceType === "Xử lý yêu cầu" ? 2 : 1}
                  setSelectMenu={setSelectMenu}
                  fetchData={fetchData}
                  point={row.original.testPoint}
                  modifiedPoint={row.original.modifiedPoint}
                />
              </Menu.Dropdown>
            </Menu>
          </Flex>
        ),
      },
    ],
    [selectMenu, dataTestLevel],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  function getColorStatus(text: any) {
    switch (text) {
      case "TAO_MOI":
        return sky_blue.base;
      case "PHAN_CONG":
        return orange.base;
      // case "TIEP_NHAN":
      //   return "#ffab09";
      case "DANG_KIEM_TRA":
        return "#d9d02f";
      // case "DA_KIEM_TRA":
      //   return "green";
      case "TEST_MOT_PHAN":
        return "#ffcc00";
      case "TEST_LOI":
        return "red";
      case "TEST_OK":
        return "#17a2b8";
      case "HUY_PHAN_CONG":
        return "red";
      case "":
        return "green";
      default:
        return sky_blue.base;
    }
  }

  const getColorTestDifficulty = (value: string | null) => {
    switch (value) {
      case "KHONG_TEST":
        return "#D3D3D3";
      case "DE":
        return "#32CD32";
      case "DON_GIAN":
        return "#90EE90";
      case "BINH_THUONG":
        return "#FFD700";
      case "KHO":
        return "#FFA500";
      case "PHUC_TAP":
        return "#FF4500";
    }
  };

  const getDataTestDifficulty = (value: string) => {
    switch (value) {
      case "KHONG_TEST":
        return "Không test";
      case "DE":
        return "Dễ";
      case "DON_GIAN":
        return "Đơn giản";
      case "BINH_THUONG":
        return "Bình thường";
      case "KHO":
        return "Khó";
      case "PHUC_TAP":
        return "Phức tạp";
    }
  };

  const getColorSourceType = (value: string) => {
    switch (value) {
      case "NHAP_KHO_BH":
        return "orange";
      case "DON_HANG":
        return "cyan";
      case "NHAP_KHO_BH_NCC":
        return "teal";
      case "Xử lý yêu cầu":
        return "blue";
      case "LAP_RAP":
        return "green";
      case "CHUYEN_DOI_DU_LIEU":
        return "#113F67";
      case "KHAC":
        return "#748DAE";
    }
  };

  const getDataSourceType = (value: string) => {
    switch (value) {
      case "NHAP_KHO_BH":
        return "Nhập kho bảo hành";
      case "DON_HANG":
        return "Đơn hàng";
      case "NHAP_KHO_BH_NCC":
        return "Nhập kho bảo hành NCC";
      case "Xử lý yêu cầu":
        return "Xử lý yêu cầu";
      case "CHUYEN_DOI_DU_LIEU":
        return "Chuyển đổi dữ liệu";
      case "LAP_RAP":
        return "Lắp ráp";
      case "KHAC":
        return "Khác";
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate.length > 0) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate.length > 0) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.branchCode.length > 0) {
      url += search.branchCode.map((item) => `&BranchCode=${item}`).join("");
    }

    if (search.sourceType.length > 0) {
      url += search.sourceType.map((item) => `&SourceType=${item}`).join("");
    }

    if (search.EmpIds && search.EmpIds?.length > 0) {
      url += search.EmpIds?.map((item) => `&EmpIds=${item}`).join("");
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/VReportDelivery/get-list-testing${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/VReportDelivery/export-bao-cao-ki-thuat-kiem-tra?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate.length > 0) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate.length > 0) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.branchCode.length > 0) {
        url += search.branchCode.map((item) => `&BranchCode=${item}`).join("");
      }

      if (search.sourceType.length > 0) {
        url += search.sourceType.map((item) => `&SourceType=${item}`).join("");
      }

      if (search.EmpIds && search.EmpIds?.length > 0) {
        url += search.EmpIds?.map((item) => `&EmpIds=${item}`).join("");
      }

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_tinh_luong_ky_thuat_kiem_tra" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const dataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataTblBranch(
      getData
        ?.filter(
          (item) =>
            item.att2 != null && item.text != null && item.value != "-1",
        )
        ?.map((item) => ({
          value: item.att2,
          label: `${item.att2} - ${item.text}`,
          id: item.value,
        })),
    );
  };

  const getDataEmployee = async () => {
    const listBranchId = idCn.map((item) => `&ListBranchId=${item}`).join("");
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?Skip=0${listBranchId}&Take=500`,
    );

    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          ?.filter(
            (item: any) =>
              item.id != null &&
              item.fullname != null &&
              item?.attribute1 === "2",
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.code} - ${item.fullname}`,
          })),
      );
    }
  };

  const fetchDataTestDifficultys = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TechnicalTestLevel/get-list?Skip=0&Take=100",
    );

    if (res && res.success) {
      const data = res.data;
      setDataTestLevel(
        data
          ?.filter((i: any) => i.name && i.code)
          ?.map((i: any) => ({
            label: String(i.name),
            value: String(i.code),
          })),
      );
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchDataTestDifficultys();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    const filteredIds = dataTblBranch
      .filter((item) => search.branchCode.includes(item.value))
      .map((item) => item.id);

    setIdCn(filteredIds);
  }, [search.branchCode]);

  useEffect(() => {
    if (idCn && idCn.length > 0) {
      getDataEmployee();
    }
  }, [idCn]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => handleExportData()}
              >
                Export Excel
              </Menu.Item>
              <Tooltip label={"Chức năng đang update"}>
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Import Excel
                </Menu.Item>
              </Tooltip>
            </Menu.Dropdown>
          </Menu>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataTblBranch.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              onClick={() => {
                if (dataTblBranch.length === 0) {
                  dataBranchSelect();
                }
              }}
              leftSection={
                <IconBrandBootstrap size={20} style={{ color: teal.base }} />
              }
              onChange={(e) => {
                handleChangeSearchValue(e ? e : [], "branchCode");
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã hoặc tên nhân viên"
              data={dataEmployeeSelect}
              searchable
              clearable
              leftSection={<IconUser color="#15aabf" />}
              value={search?.EmpIds ?? []}
              onChange={(value) =>
                handleChangeSearchValue(value ? value : [], "EmpIds")
              }
              nothingFoundMessage={
                search?.branchCode && search?.branchCode.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Hãy chọn chi nhánh trước !"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={"Nguồn chứng từ"}
              clearable
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={sourceTypeData}
              leftSection={<IconMapRoute color="#15aabf" />}
              onChange={(value) =>
                handleChangeSearchValue(value ? value : [], "sourceType")
              }
              value={search.sourceType}
              renderOption={(option) => (
                <Group flex="1" gap="xs">
                  <Badge
                    color={
                      option.option.value === "DON_HANG"
                        ? "cyan"
                        : option.option.value === "NHAP_KHO_BH"
                          ? "orange"
                          : option.option.value === "CHUYEN_DOI_DU_LIEU"
                            ? "#113F67"
                            : option.option.value === "NHAP_KHO_BH_NCC"
                              ? "teal"
                              : option.option.value === "Xử lý yêu cầu"
                                ? "blue"
                                : option.option.value === "LAP_RAP"
                                  ? "green"
                                  : option.option.value === "KHAC"
                                    ? "#748DAE"
                                    : ""
                    }
                    radius="sm"
                    variant="filled"
                  >
                    {option.option.label}
                  </Badge>
                </Group>
              )}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });

  return (
    <>
      <MantineReactTable table={table} />
    </>
  );
};
export default PayrollReport;
